import { IStatePlayer } from '../State/reducers/player';
import { Views } from '../State/reducers/view';
import { Collection } from '../Tiles/TileSet';

export const OVERWRITE_LIST: string[] = ['gamebgs', 'worldmap'];

export const AUDIO_OVERWRITES: string[] = [
    'machu-map',
    'machu-game',
    'rome-game',
    'rome-map',
    'seoul-map',
    'seoul-game',
    'scotland-map',
    'scotland-game',
    'morocco-map',
    'morocco-game',
    'newyork-map',
    'newyork-game',
];

export const FTUE_LIST = [
    'gamebgs',
    'level-001',
    'tiles',
    'fx',
    'commonui',
    'gameui',
    'tutorial',
    'character',
];

export const MAP_ASSET_LIST = [
    'worldmap',
    'map-path',
    '-levels',
    'commonui',
    'mapui',
    'character',
    'fx',
    'character',
    // share images (if needed)
];

export const GAME_LIST = [
    'gamebgs',
    'tiles',
    'fx',
    'commonui',
    'gameui',
    'boosterfx',
    'character',
    'tutorial',
    'styleWinText',
];

// always create list of all assets, just different order
// if a new list is generated it will grab the same promises, those already loaded will be resolved already
export function getAssetList(
    view: string,
    playerData: IStatePlayer,
    newPlayer: boolean,
    concat: boolean = false
) {
    let list: string[] = [];

    if (newPlayer) {
        list = [...FTUE_LIST];
    }

    if (view === Views.GAME) {
        list = [...getGameList(playerData)];
    }

    if (view === Views.MAP) {
        list = [...getMapList(playerData)];
    }

    return list;
}

function getMapList(playerData: IStatePlayer) {
    const mapList: string[] = [];
    MAP_ASSET_LIST.forEach(l => {
        let listKey = l;
        l = l.split('@')[0];
        if (l === '-levels') {
            listKey = playerData.mapId + l;
        }

        if (OVERWRITE_LIST.includes(l)) {
            listKey = playerData.mapId + '-map/' + l;
        }
        mapList.push(listKey);
    });

    return mapList;
}

function getGameList(playerData: IStatePlayer) {
    const gameList: string[] = [];
    GAME_LIST.forEach(l => {
        let listKey = l;
        l = l.split('@')[0];
        if (l === '-levels') {
            listKey = playerData.mapId + l;
        }

        if (OVERWRITE_LIST.includes(l)) {
            listKey = playerData.mapId + '-game/' + l;
        }
        gameList.push(listKey);
    });
    if (playerData.activeCollection !== Collection.DEFAULT) {
        gameList.push(`tiles-${playerData.activeCollection}`);
    }
    return gameList;
}
